import { Tenant } from "rp-components"
import { apiClient } from "rp-components"

export interface TenantService {
    getTenants(propertyId: number): Promise<Tenant[]>
    getTenant(propertyId: number, tenantId: String): Promise<Tenant>
    getSubTenant(propertyId: number, tenantId: String, subTenantId: string): Promise<Tenant>
}

class TenantServiceImpl implements TenantService {
    static instance?: TenantService = undefined

    private constructor() {}

    static getInstance(): TenantService {
        if (TenantServiceImpl.instance == undefined) {
            TenantServiceImpl.instance = new TenantServiceImpl()
        }
        return TenantServiceImpl.instance
    }

    async getTenants(propertyId: number): Promise<Tenant[]> {
        return await apiClient.get(`/properties/${propertyId}/directory/tenants`)
    }

    async getTenant(propertyId: number, tenantId: String): Promise<Tenant> {
        return apiClient.get(`/properties/${propertyId}/directory/tenants/${tenantId}`)
    }

    async getSubTenant(propertyId: number, tenantId: String, subTenantId: string): Promise<Tenant> {
        return apiClient.get(`/properties/${propertyId}/directory/tenants/${tenantId}/subtenants/${subTenantId}`)
    }
}

export default TenantServiceImpl.getInstance()
